import { VAS_SERVICE_API } from '@/const';
import { request } from 'ice';

async function getTableList(data) {
  return await request.get(`${VAS_SERVICE_API}/valueAddedTask/detail`, { params: data });
}

// 获取综合信息数据
async function getGeneralTableData(data) {
  const res = await request.post('', data);

  return {
    total: res.totalElements,
    list: res.list,
  };
}

// 附件上传
async function attachmentUpload(data) {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/uploadValueAddedTaskAttach`, data);
}

// 提交
async function submitData(data: object) {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/complete`, data);
}

// 操作日志数据
async function getLogData(data: object) {
  return await request.get(`${VAS_SERVICE_API}/valueAddedTask/showLog`, { params: data });
}

async function queryRelativeNoApi(data: object) {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/queryRelativeNo`, data);
}

async function getVasInventoryApi(consignmentNo) {
  return await request.get(`${VAS_SERVICE_API}/valueAddedTask/matchInventory`, { params: { consignmentNo } });
}

export {
  getTableList,
  getGeneralTableData,
  attachmentUpload,
  submitData,
  getLogData,
  queryRelativeNoApi,
  getVasInventoryApi,
};
